import { BaseModel } from "../../../../../core/util/BaseModel";
import { observable, action, makeObservable } from "mobx";
import { Enums } from "../../../../../enums";
import ImpactGroupsApi, {
  ImpactGroupsApi as IImpactGroupsApi
} from "../../../../../services/api/v2/impactGroups/ImpactGroups.api";

export class ImpactStakeholderListViewModel extends BaseModel {
  impactGroupProvider: IImpactGroupsApi;
  organisationId: number;
  @observable isSearchMode: boolean = false;
  @observable searchValue: string = "";
  @observable stakeholders: FP.Entities.IStakeholder[] = [];
  @observable impactGroupStakeholders;
  @observable filteredStakeholders: FP.Entities.IStakeholder[] = [];
  projectId: number;
  impactGroupId: number;
  @observable isLoading: boolean = true;

  constructor(organisationId: number, projectId: number, impactGroupId: number) {
    super();
    makeObservable(this);
    this.organisationId = organisationId;
    this.impactGroupId = impactGroupId;
    this.projectId = projectId;
    this.impactGroupProvider = ImpactGroupsApi;
  }

  @action
  onMount = async () => {
    await this.loadImpactGroupStakeholders(this.organisationId);
    this.setIsLoading(false);
  };

  onUnmount = () => {
    this.resetSearch();
  };

  @action
  updateSearchValue = (e: React.FormEvent<HTMLInputElement>) => {
    this.searchValue = e.currentTarget.value;
    this.filterStakeholders();
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  @action
  showSearchMode = () => {
    this.isSearchMode = true;
  };

  @action
  hideSearchMode = () => {
    this.isSearchMode = false;
  };

  @action
  resetSearch = () => {
    this.searchValue = "";
    this.filterStakeholders();
    this.hideSearchMode();
  };

  @action
  filterStakeholders = () => {
    if (this.searchValue) {
      const lowerSearch = this.searchValue.toLowerCase();
      this.filteredStakeholders = this.stakeholders.filter(stakeholder => {
        const name =
          stakeholder.stakeholderType === Enums.StakeholderType.INDIVIDUAL
            ? `${stakeholder.firstName} ${stakeholder.lastName}`
            : stakeholder.firstName;
        const lowerName = name.toLowerCase();

        return lowerName.includes(lowerSearch);
      });
    } else {
      this.filteredStakeholders = this.stakeholders;
    }
  };

  @action
  loadImpactGroupStakeholders = async organisationId => {
    let res = await this.impactGroupProvider.getImpactGroupStakeholders(
      organisationId,
      this.projectId,
      this.impactGroupId
    );

    if (!res) return;
    this.stakeholders = res.payload;
    this.filteredStakeholders = res.payload;
  };
}
